const ack = 'ACK';
const nAck = 'NACK';
const pending = 'PENDING';
const error = 'ERROR';
const unknown = 'UNKNOWN';
const init = 'INIT';
const pendingApproval = 'PENDING_APPROVAL';
const approved = 'APPROVED';
const denied = 'DENIED';
const expired = 'EXPIRED';

export const coaStatusEnum = {
  ack,
  nAck,
  pending,
  error,
};

export const statusEnum = {
  unknown,
  init,
  pendingApproval,
  approved,
  denied,
  expired,
};

export const countryCodes = [
  { code: 'US', label: 'United States', dialCode: '+1' },
  { code: 'IN', label: 'India', dialCode: '+91' },
  { code: 'KSA', label: 'Saudi Arabia', dialCode: '+966', regex: /^(\+966|0)?5[0-9]{8}$/ },
];
